import type { DefaultTheme } from 'styled-components';
import { TypographyType } from '../enums/type';

export const getTypographyTypeColor = (type: TypographyType | undefined, theme: DefaultTheme) => {
  switch (type) {
    case TypographyType.Normal:
      return theme.color.semantic.type.primary;
    case TypographyType.Secondary:
      return theme.color.semantic.type.secondary;
    case TypographyType.Inverted:
      return theme.color.semantic.type.inverted;
    case TypographyType.Error:
      return theme.color.semantic.feedback.type.error;
    case TypographyType.Warning:
      return theme.color.semantic.feedback.type.warning;
    default:
      return theme.color.semantic.type.primary;
  }
};
